import { render, staticRenderFns } from "./OlabProjectSVGGen.vue?vue&type=template&id=296ece2e&"
import script from "./OlabProjectSVGGen.vue?vue&type=script&lang=js&"
export * from "./OlabProjectSVGGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports